import {
  mountViewport,
  viewportContentSafeAreaInsetBottom,
  viewportContentSafeAreaInsetLeft,
  viewportContentSafeAreaInsetRight,
  viewportContentSafeAreaInsetTop,
  viewportSafeAreaInsetBottom,
  viewportSafeAreaInsetLeft,
  viewportSafeAreaInsetRight,
  viewportSafeAreaInsetTop,
} from '@telegram-apps/sdk-react';

/**
 * Резерв для обычного браузера — та же геометрия, что и в макете (design/design-spec.md:
 * «Экран: 380 × 812, safe area 44 сверху / 34 снизу»). Держится, пока Telegram
 * ничего не сообщил, и заменяется настоящими значениями, как только viewport смонтирован.
 */
const FALLBACK = { top: 44, bottom: 34, left: 0, right: 0 };

function apply(top: number, bottom: number, left: number, right: number): void {
  const root = document.documentElement.style;
  root.setProperty('--clown-safe-top', `${top}px`);
  root.setProperty('--clown-safe-bottom', `${bottom}px`);
  root.setProperty('--clown-safe-left', `${left}px`);
  root.setProperty('--clown-safe-right', `${right}px`);
}

function sync(): void {
  // Сумма двух инсетов: safeArea — вырез устройства, contentSafeArea — шапка
  // и системные кнопки самого Telegram поверх нашей разметки.
  const top = viewportSafeAreaInsetTop() + viewportContentSafeAreaInsetTop();
  const bottom = viewportSafeAreaInsetBottom() + viewportContentSafeAreaInsetBottom();
  const left = viewportSafeAreaInsetLeft() + viewportContentSafeAreaInsetLeft();
  const right = viewportSafeAreaInsetRight() + viewportContentSafeAreaInsetRight();
  apply(top || FALLBACK.top, bottom || FALLBACK.bottom, left, right);
}

/**
 * Пробрасывает safe area в CSS-переменные `--clown-safe-*`. Вызывать после
 * успешного init() — до него SDK не сконфигурирован, и mountViewport
 * недоступен даже внутри настоящего Telegram.
 */
export function setupSafeArea(): void {
  apply(FALLBACK.top, FALLBACK.bottom, FALLBACK.left, FALLBACK.right);
  if (!mountViewport.isAvailable()) return;

  mountViewport()
    .then(() => {
      sync();
      for (const signal of [
        viewportSafeAreaInsetTop,
        viewportSafeAreaInsetBottom,
        viewportSafeAreaInsetLeft,
        viewportSafeAreaInsetRight,
        viewportContentSafeAreaInsetTop,
        viewportContentSafeAreaInsetBottom,
        viewportContentSafeAreaInsetLeft,
        viewportContentSafeAreaInsetRight,
      ]) {
        signal.sub(sync);
      }
    })
    .catch(() => {
      // Не в Telegram — резервные значения уже применены выше.
    });
}
